import React from 'react';
import { injectGlobal } from 'emotion';
import normalize from 'normalize.css/normalize.css';
import { setConfig } from 'react-hot-loader';

import SEO from './Seo';

setConfig({ pureSFC: true });

injectGlobal`
${normalize}
body {
  font-family: 'Helvetica Neue', system-ui, sans-serif;
  font-size: 12px;
  line-height: 1.8em;
  letter-spacing: .2em;
  text-transform: uppercase;
  background-color: #000;
}

section {
  position: relative;
}

h4 {
  font-size: 1.2em;
  margin: 0px 0;
  letter-spacing: 0.28em;
}

h5 {
  font-weight: normal;
  font-size: 0.8em;
  letter-spacing: 0.33em;
  margin: 0;
}

a, a:hover, a:visited {
  color: #fff;
  font-style: normal;
  text-decoration: none;
  text-transform: none;
}
`;

const Layout = ({ seo, children }) => (
  <>
    <SEO seo={seo} />
    <main>{children}</main>
  </>
);

export default Layout;
